import { DataGrid } from '@mui/x-data-grid';
import './css/LeadsView.css';
import React, { useState, useEffect } from 'react';
import axios from "axios";
import api from "../config/backend";
import { Button, Popover } from '@mui/material';
import { useOutletContext } from 'react-router-dom';


const columns = [
  { field: 'clientname', headerName: 'name', width: 130, sticky: 'left', headerAlign: 'center', align: 'center' }, // Make the "NAME" column sticky
  { field: 'company', headerName: 'company', width: 130, headerAlign: 'center', align: 'center' }, // Adjust alignment for other columns
  { field: 'tags', headerName: 'tags', width: 130, headerAlign: 'center', align: 'center', renderTags: (params) => renderTags(params) },
  { field: 'dealsize', headerName: 'deal size', width: 130, headerAlign: 'center', align: 'center' },
  { field: 'lastcontact', headerName: 'last contact', width: 130, headerAlign: 'center', align: 'center' },
  { field: 'stage', headerName: 'stage', width: 130, headerAlign: 'center', align: 'center' },
  { field: 'conversion', headerName: 'conversion', width: 130, headerAlign: 'center', align: 'center' },
  { field: 'owner', headerName: 'owner', width: 130, headerAlign: 'center', align: 'center' },
  { field: 'clientemail', headerName: 'email', width: 130, headerAlign: 'center', align: 'center' },
  { field: 'website', headerName: 'website', width: 130, headerAlign: 'center', align: 'center' },
];

// const rows = [
//   { id: 1, name: 'pranathi', company: 'Vibho', tags: 'Jon', dealsize: 35, lastcontact: 'Last Tuesday', stage: 'Qualified', conversion: '', owner: '', created: '', email: 'pranathi@gmail.com', website: '' },
//   { id: 2, name: '', company: '', tags: '', dealsize: '', lastcontact: '', stage: '', conversion: '', owner: '', created: '', email: '', website: '' },
// ];
export function renderTags(params) {
  const tags = params.row.tags;

  if (!tags || tags.length === 0) {
    return null;
  }

  const firstTag = tags[0].name;
  const remainingTags = tags.slice(1);

  const handlePopoverOpen = (event) => {
    params.setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    params.setAnchorEl(null);
  };

  return (
    <div>
      <span>{firstTag}</span>
      {remainingTags.length > 0 && (
        <Button variant="text" size="small" onClick={handlePopoverOpen}>
          +1
        </Button>
      )}
      <Popover
        open={Boolean(params.anchorEl)}
        anchorEl={params.anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: '8px' }}>
          {remainingTags.map((tag, index) => (
            <div key={index}>{tag.name}</div>
          ))}
        </div>
      </Popover>
    </div>
  );
}




function LeadsView() {
  const searchLead = useOutletContext()[2]
  const [rows, setRows] = useState([])
  const token = localStorage.getItem("_crm__token")

  const fetchLeads = async () => {
    const { data, status } = await axios.post(`${api}/Leads/fetch-leads`, { token, view: "list" })
    console.log({ data })
    if (data.success) {
      const formattedRows = data.leads.map((item, index) => {
        const copy = { ...item };
        copy.id = index;
        if (Array.isArray(copy.tags) && copy.tags.length > 0) {
          copy.tags = copy.tags.map(tag => tag.name).join(', ');
        } else {
          copy.tags = '';
        }

        return copy;
      });

      setRows(formattedRows);
    }
  }

  useEffect(() => {
    fetchLeads()
  }, [])


  console.log({ rows })

  // const addtages = rows.map((item, index) => {
  //   const uploadTages = { ...item.tags }
  //   console.log(uploadTages)
  //   return (
  //     uploadTages
  //   )
  // })
  // console.log(addtages)



  return (
    <div className="app-table">
      <DataGrid
        rows={rows.filter(item => (item.clientemail && item.clientemail.toLowerCase().includes(searchLead.toLowerCase())) || (item.clientname && item.clientname.toLowerCase().includes(searchLead.toLowerCase())))}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
      />
    </div>
  );
}

export default LeadsView;
